import { connect } from 'react-redux'
import { actions } from '@bt-react/store'
import { ResourcesProps } from '@bt-react/store'
import AttachmentsListItem from './AttachmentsListItem'

const mapStateToProps = (state) => {

    return {
        status: state.resources && state.resources.status
    }

}

const mapDispatchToProps = (dispatch: any) => ({
    setView: (view: string) =>
        dispatch(actions.resource.setAttachmentView(view)),
    selectAttachment: (attachmentInfo: ResourcesProps) =>
        dispatch(actions.resource.selectAttachment(attachmentInfo))
})

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentsListItem)